import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsShortDescriptionStyles {
    wrapper?: InjectableCss;
}

export const descriptionStyles: ProductDetailsShortDescriptionStyles = {
    wrapper: {
        css: css`
            font-weight:bold;
        `,
    },
};

const styles = descriptionStyles;

const ProductDetailsShortDescription: React.FC<Props> = ({ product }) => {
    if (!product.content) {
        return null;
    }
    const shortDescription=product.specifications?.find(p=>p.name==="Short Description1")?.htmlContent || "";
    return (
        <StyledWrapper {...styles.wrapper}>
            <div data-test-selector="productDetails_short_descriptions_htmlContent">
                {parse(shortDescription, parserOptions)}
            </div>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsShortDescription),
    definition: {
        displayName: "Short Description",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
